/**
 * Retorna um UUID
 * @function
 * @name UUID
 * @return {string} - UUID.
 */
export default function UUID () {
    return Math.floor(new Date().valueOf() * Math.random())
}
